export default (settings: any) => {
  if (settings['extendedNavigation'] === false) {
    return 0
  }
  return settings['entities'] * (1 / 60) * 2 + settings['foreignKeys'] * (1 / 60) * 2
}
